import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import './LegalPage.css';

export function TermsPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <span className="legal-nav-logo" onClick={() => navigate('/')}>My Job Odyssey</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <LanguageSwitcher />
          <button className="legal-nav-back" onClick={() => navigate('/')}>
            &larr; {t('legal.backToHome')}
          </button>
        </div>
      </nav>

      <div className="legal-content">
        <h1>{t('legal.terms.title')}</h1>
        <p className="legal-updated">{t('legal.lastUpdated')}</p>
        <p className="legal-intro">{t('legal.terms.intro')}</p>

        <section className="legal-section">
          <h2>{t('legal.terms.betaTitle')}</h2>
          <p>{t('legal.terms.betaText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.dataLossTitle')}</h2>
          <p>{t('legal.terms.dataLossText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.accountTitle')}</h2>
          <p>{t('legal.terms.accountText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.aiTitle')}</h2>
          <p>{t('legal.terms.aiText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.useTitle')}</h2>
          <p>{t('legal.terms.useText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.warrantyTitle')}</h2>
          <p className="legal-caps">{t('legal.terms.warrantyText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.liabilityTitle')}</h2>
          <p className="legal-caps">{t('legal.terms.liabilityText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.indemnityTitle')}</h2>
          <p>{t('legal.terms.indemnityText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.terminationTitle')}</h2>
          <p>{t('legal.terms.terminationText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.changesTitle')}</h2>
          <p>{t('legal.terms.changesText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.lawTitle')}</h2>
          <p>{t('legal.terms.lawText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.terms.contactTitle')}</h2>
          <p>{t('legal.terms.contactText')}</p>
        </section>
      </div>

      <div className="legal-footer">
        &copy; {new Date().getFullYear()} {t('home.footer.copyright')}
      </div>
    </div>
  );
}
